var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInputErrorIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 0.5C10.0899 0.5 13 3.41015 13 7C13 10.5899 10.0899 13.5 6.5 13.5C2.91015 13.5 0 10.5899 0 7C0 3.41015 2.91015 0.5 6.5 0.5ZM7.10938 7.40625C7.10938 7.7428 6.83655 8.01562 6.5 8.01562C6.16345 8.01562 5.89062 7.7428 5.89062 7.40625V3.75C5.89062 3.41345 6.16345 3.14062 6.5 3.14062C6.83655 3.14062 7.10938 3.41345 7.10938 3.75V7.40625ZM6.5 9.03125C6.05127 9.03125 5.6875 9.39502 5.6875 9.84375C5.6875 10.2925 6.05127 10.6562 6.5 10.6562C6.94873 10.6562 7.3125 10.2925 7.3125 9.84375C7.3125 9.39502 6.94873 9.03125 6.5 9.03125Z",
    fill: "#E60000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInputErrorIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/input-error-icon.50cd6748952fda1e59cf7a63a8e143f9.svg";